import { type Env, GNB } from '@bucketplace/common';
import { NavigationTopBanner } from '@bucketplace/design-system/bds';
import { useLocation } from '@bucketplace/next-extra';
import React from 'react';
import { useMounted } from '@/hooks/use-mounted';
import { useUserContext } from '@/provider';
import {
  getDeepLink,
  getQuery,
  handleLogWithCookie,
  handleOpenApp,
  isInApp,
  setCookie,
} from '@/utils';
import { SuperLink } from '../Link/SuperLink';
import { LAYOUT_HEADER_ID } from './constants';

export const Header = ({
  hideGnbInSSR = false,
}: {
  hideGnbInSSR?: boolean;
}): React.ReactElement => {
  const { userInfo, pcBanner, mobileBanner, nav, rawLoginUser } =
    useUserContext();
  const { pathname, search } = useLocation();
  const mounted = useMounted();

  const isBigPromotionPage = pathname.includes('big-promotion');

  const localeData = {
    mobileBanner: {
      title: isBigPromotionPage
        ? '매일 ~90% 쿠폰 당첨 기회\n앱 알림 신청 후 놓치지 마세요!'
        : '앱에서는 1초만에!\n간편하게 로그인하기',
      appDownloadButtonText: isBigPromotionPage ? '앱 열기' : '앱으로 보기',
    },
    mobilePopup: {
      title: isBigPromotionPage
        ? '매일 ~90% 쿠폰 당첨 기회\n앱 알림 신청 후 놓치지 마세요!'
        : '앱에서는 1초만에!\n간편하게 로그인하기',
      description: '특가, 쿠폰 등 앱 전용 혜택까지',
      appDownloadButtonText: isBigPromotionPage
        ? '앱에서 쿠폰 받기'
        : '편리한 앱으로 보기',
      remainWebButtonText: isBigPromotionPage
        ? '웹으로 보기'
        : '모바일 웹으로 볼래요',
    },
  };

  const handleAppDownloadPopupClose = (): void => {
    setCookie('ohsAppDownloadPopupClosed', 'yes', 24 * 3600 * 1000);
  };

  return (
    <div id={LAYOUT_HEADER_ID}>
      {(pcBanner || mobileBanner) && (
        <NavigationTopBanner
          location={{
            pathname,
            search,
          }}
          pcContentList={pcBanner ?? undefined}
          mobileImageSrc={mobileBanner ?? undefined}
          linkComponent={SuperLink}
          onCloseAppDownloadPopup={handleAppDownloadPopupClose}
          onAppOpen={handleOpenApp}
          onLog={handleLogWithCookie}
          isUserLoggedIn={!!userInfo?.user}
          localeData={localeData}
        />
      )}
      {(!hideGnbInSSR || mounted) && !isInApp(getQuery(search)) && (
        <GNB
          linkComponent="a"
          location={{
            pathname,
            search,
            origin: process.env.NEXT_PUBLIC_EVENT_HOST!,
            hash: '',
          }}
          env={process.env.APP_PROFILE as Env}
          subdomain="events"
          menus={nav?.menus}
          supplementary={nav?.supplementary}
          searchMenus={nav?.searchMenus}
          trendingKeywords={nav?.trendingKeywords}
          getDeepLink={getDeepLink}
          user={rawLoginUser ?? null}
        />
      )}
    </div>
  );
};
